module.exports = __webpack_public_path__ + "static/media/FrancoisGuerrier.061bcac5.jpg";